exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slider {\n  background: #ccc;\n  overflow: hidden;\n  position: relative;\n}\n.slider .title {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  color: #fff;\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));\n  padding: 0 0.26666667rem;\n  line-height: 0.8rem;\n  font-size: 0.37333333rem;\n  pointer-events: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-50601f12!./~/autoprefixer-loader!./~/px2rem-loader?remUnit=37.5&remPrecision=8!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Slider.vue
// module id = 91
// module chunks = 1